import { render, staticRenderFns } from "./BulmaModal.vue?vue&type=template&id=56051461&"
import script from "./BulmaModal.vue?vue&type=script&lang=js&"
export * from "./BulmaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports